/* eslint-disable no-console */
import { get } from 'lodash';

import GearzettePageQuery from 'Query/GearzettePage.query';
import { setPostDetailsLoading, updateGearzettePagePostDetails } from 'Store/GearzettePage';
import { updateNoMatch } from 'Store/NoMatch/NoMatch.action';
import { QueryDispatcher } from 'Util/Request';

/** @namespace Pwa/Store/GearzettePage/PostDetails/Dispatcher/PostDetailsDispatcher */
export class PostDetailsDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct();
    }

    // eslint-disable-next-line no-unused-vars
    onSuccess(response, dispatch, { cb }) {
        const postDetails = get(response, 'post', []);
        dispatch(updateGearzettePagePostDetails(postDetails, false));
    }

    onError(_, dispatch) {
        dispatch(setPostDetailsLoading(false));
        dispatch(updateNoMatch(true));
    }

    prepareRequest(options, dispatch) {
        dispatch(setPostDetailsLoading(true));
        return GearzettePageQuery.getQueryPostDetails(options);
    }
}

export default new PostDetailsDispatcher();
